import { roles } from 'common/constants/options';

// El tour aplica a cliente, entrenador, supervisor y al gestor de empresa (panel Prometeo).
// Cada paso apunta a un elemento real del menú (data-tour = itemKey del MenuItem) o de la vista,
// para que react-joyride lo resalte (spotlight). Los pasos cuyo elemento no exista en el DOM
// (según plataforma, ruta actual o en móvil) se filtran en RoleTour.
export const roleGroup = (role, isOrgManager = false) => {
  if (role === roles.trainer) return 'trainer';
  if (role === roles.supervisor) return 'supervisor';
  // El gestor de empresa es un CLIENT con flag, pero su menú es otro por completo: con el grupo
  // 'client' ninguna de sus anclas existía y el tour quedaba en un cascarón de un paso.
  if (isOrgManager) return 'orgClient';
  return 'client';
};

const STEPS = {
  client: [
    { key: 'welcome', target: 'body', placement: 'center' },
    { key: 'home', target: '[data-tour="home"]', placement: 'right' },
    { key: 'news', target: '[data-tour="news"]', placement: 'right' },
    // OTRIX Play (solo visibles para ese canal; se auto-filtran por DOM en RoleTour)
    { key: 'playHome', target: '[data-tour="otrix-play"]', placement: 'right' },
    { key: 'playRoutine', target: '[data-tour="play-routine"]', placement: 'right' },
    { key: 'playWorkout', target: '[data-tour="play-workout"]', placement: 'right' },
    { key: 'playForum', target: '[data-tour="play-forum"]', placement: 'right' },
    { key: 'calendar', target: '[data-tour="calendar"]', placement: 'right' },
    { key: 'sessions', target: '[data-tour="my-sessions"]', placement: 'right' },
    { key: 'program', target: '[data-tour="my-program"]', placement: 'right' },
    { key: 'performance', target: '[data-tour="performance"]', placement: 'right' },
    { key: 'progress', target: '[data-tour="progress"]', placement: 'right' },
    { key: 'ranking', target: '[data-tour="ranking"]', placement: 'right' },
    { key: 'gamification', target: '[data-tour="gamification"]', placement: 'right' },
    { key: 'payments', target: '[data-tour="payments"]', placement: 'right' },
    { key: 'myOrganization', target: '[data-tour="my-organization"]', placement: 'right' },
    { key: 'profile', target: '[data-tour="profile"]', placement: 'right' },
    { key: 'legal', target: '[data-tour="legal"]', placement: 'right' },
    { key: 'theme', target: '[data-tour="theme-toggle"]', placement: 'bottom' },
    { key: 'replay', target: '[data-tour="tour-replay"]', placement: 'right' }
  ],
  trainer: [
    { key: 'welcome', target: 'body', placement: 'center' },
    { key: 'home', target: '[data-tour="home"]', placement: 'right' },
    { key: 'news', target: '[data-tour="news"]', placement: 'right' },
    { key: 'calendar', target: '[data-tour="calendar"]', placement: 'right' },
    { key: 'availability', target: '[data-tour="availability"]', placement: 'right' },
    { key: 'sessions', target: '[data-tour="sessions"]', placement: 'right' },
    { key: 'groupSessions', target: '[data-tour="trainerGroupSessions"]', placement: 'right' },
    { key: 'clients', target: '[data-tour="client"]', placement: 'right' },
    { key: 'nutrition', target: '[data-tour="nutrition-admin"]', placement: 'right' },
    { key: 'performance', target: '[data-tour="performance"]', placement: 'right' },
    { key: 'ranking', target: '[data-tour="ranking"]', placement: 'right' },
    { key: 'exercises', target: '[data-tour="exercises"]', placement: 'right' },
    { key: 'payments', target: '[data-tour="payment"]', placement: 'right' },
    { key: 'profile', target: '[data-tour="profile"]', placement: 'right' },
    { key: 'legal', target: '[data-tour="legal"]', placement: 'right' },
    { key: 'theme', target: '[data-tour="theme-toggle"]', placement: 'bottom' },
    { key: 'replay', target: '[data-tour="tour-replay"]', placement: 'right' }
  ],
  // Supervisor: menú de solo lectura/control (no crea sesiones ni entrena). Espeja los ítems
  // reales de SupervisorDesktopMenu.
  supervisor: [
    { key: 'welcome', target: 'body', placement: 'center' },
    { key: 'home', target: '[data-tour="home"]', placement: 'right' },
    { key: 'news', target: '[data-tour="news"]', placement: 'right' },
    { key: 'calendar', target: '[data-tour="calendar"]', placement: 'right' },
    { key: 'sessions', target: '[data-tour="sessions"]', placement: 'right' },
    { key: 'plans', target: '[data-tour="plans"]', placement: 'right' },
    { key: 'ranking', target: '[data-tour="ranking"]', placement: 'right' },
    { key: 'payments', target: '[data-tour="payments"]', placement: 'right' },
    { key: 'users', target: '[data-tour="users"]', placement: 'right' },
    { key: 'profile', target: '[data-tour="profile"]', placement: 'right' },
    { key: 'theme', target: '[data-tour="theme-toggle"]', placement: 'bottom' }
  ],
  // Gestor de empresa (panel Prometeo). Las anclas del menú salen gratis del `itemKey`
  // de MenuItem; las de dentro de las vistas solo aparecen si está en esa ruta, y RoleTour
  // filtra por DOM las que no existan, así que no rompen el recorrido.
  orgClient: [
    { key: 'welcome', target: 'body', placement: 'center' },
    { key: 'home', target: '[data-tour="org-home"]', placement: 'right' },
    { key: 'index', target: '[data-tour="org-index"]', placement: 'bottom' },
    { key: 'privacy', target: '[data-tour="org-privacy"]', placement: 'bottom' },
    { key: 'wellbeing', target: '[data-tour="org-wellbeing"]', placement: 'right' },
    { key: 'departments', target: '[data-tour="org-departments"]', placement: 'right' },
    { key: 'members', target: '[data-tour="org-members"]', placement: 'right' },
    { key: 'reports', target: '[data-tour="org-reports"]', placement: 'right' },
    { key: 'plans', target: '[data-tour="org-plans"]', placement: 'right' },
    { key: 'theme', target: '[data-tour="theme-toggle-sidebar"]', placement: 'right' },
    { key: 'replay', target: '[data-tour="tour-replay"]', placement: 'right' }
  ]
};

// Pasos MÓVIL: ya no hay barra inferior — la navegación completa vive en el drawer
// (hamburguesa). El tour abre el drawer (RoleTour) y reutiliza las MISMAS anclas
// `data-tour` del menú de desktop, que ahora existen dentro del panel. Solo la
// bienvenida y el paso de la hamburguesa son propios de móvil.
const MOBILE_INTRO = {
  client: [
    { key: 'welcomeMobile', target: 'body', placement: 'center', dt: '¡Bienvenido a OTRIX!', db: 'Te mostramos lo básico en 30 segundos.' },
    { key: 'menuToggle', target: '[data-tour="menu-toggle"]', placement: 'top', dt: 'Tu menú', db: 'Toca tu foto para abrir la navegación completa. Te la mostramos.' }
  ],
  trainer: [
    { key: 'welcomeMobile', target: 'body', placement: 'center', dt: '¡Bienvenido a OTRIX!', db: 'Te mostramos lo básico en 30 segundos.' },
    { key: 'menuToggle', target: '[data-tour="menu-toggle"]', placement: 'top', dt: 'Tu menú', db: 'Toca tu foto para abrir la navegación completa. Te la mostramos.' }
  ],
  supervisor: [
    { key: 'welcomeMobile', target: 'body', placement: 'center', dt: '¡Bienvenido a OTRIX!', db: 'Te mostramos lo básico en 30 segundos.' },
    { key: 'menuToggle', target: '[data-tour="menu-toggle"]', placement: 'top', dt: 'Tu menú', db: 'Toca tu foto para abrir la navegación completa. Te la mostramos.' }
  ],
  orgClient: [
    { key: 'welcomeMobile', target: 'body', placement: 'center', dt: 'Bienvenido a Prometeo', db: 'Te mostramos tu panel en 30 segundos.' },
    { key: 'menuToggle', target: '[data-tour="menu-toggle"]', placement: 'top', dt: 'Tu menú', db: 'Toca tu foto para abrir la navegación completa. Te la mostramos.' }
  ]
};

/**
 * Construye los pasos de react-joyride para el rol dado, resolviendo los textos desde el
 * namespace `tour`. En móvil: bienvenida + hamburguesa + los pasos del menú de desktop
 * (mismas anclas dentro del drawer abierto) + toggle de tema del sidebar.
 */
// El velo de joyride SOLO se conserva en los pasos centrados en `body`.
//
// En los pasos anclados no aporta nada —el spotlight está apagado y el resaltado lo pone la clase
// `.otx-tour-highlight`— y en cambio es el 100% del riesgo: joyride pinta el velo mientras el tour
// corre, MIRE O NO si el ancla sigue en pantalla. Si el ancla se va (se cerró el menú, se filtró
// el buscador, se rotó el teléfono), el velo se queda solo, a pantalla completa y comiéndose los
// toques. Con `disableOverlay` en esos pasos, ese fallo pasa de "vigilado" a IMPOSIBLE.
//
// En la bienvenida el ancla es `body`, que no puede desaparecer, así que ahí el velo es seguro y
// además aporta el momento de entrada.
const anchored = (step) => ({ ...step, disableOverlay: true });

export const getTourSteps = (role, t, isMobile = false, isOrgManager = false) => {
  const group = roleGroup(role, isOrgManager);
  if (isMobile) {
    const intro = MOBILE_INTRO[group].map(({ key, target, placement, dt, db }) => {
      const step = {
        target,
        placement,
        disableBeacon: true,
        title: t(`${group}.${key}.title`, { ns: 'tour', defaultValue: dt }),
        content: t(`${group}.${key}.body`, { ns: 'tour', defaultValue: db })
      };
      return target === 'body' ? step : anchored(step);
    });
    const menuSteps = STEPS[group]
      .filter(({ key }) => key !== 'welcome' && key !== 'theme')
      .map(({ key, target }) =>
        anchored({
          target,
          placement: 'auto',
          disableBeacon: true,
          title: t(`${group}.${key}.title`, { ns: 'tour' }),
          content: t(`${group}.${key}.body`, { ns: 'tour' })
        })
      );
    const themeStep = anchored({
      target: '[data-tour="theme-toggle-sidebar"]',
      placement: 'top',
      disableBeacon: true,
      title: t(`${group}.theme.title`, { ns: 'tour' }),
      content: t(`${group}.theme.body`, { ns: 'tour' })
    });
    return [...intro, ...menuSteps, themeStep];
  }
  return STEPS[group].map(({ key, target, placement }) => {
    const step = {
      target,
      placement,
      disableBeacon: true,
      title: t(`${group}.${key}.title`, { ns: 'tour' }),
      content: t(`${group}.${key}.body`, { ns: 'tour' })
    };
    return target === 'body' ? step : anchored(step);
  });
};

export default getTourSteps;
